import { createSlice } from "@reduxjs/toolkit"

import moment from "moment"

import { REQUEST_ABORTED } from "../../lib/utils"

export const errorsSlice = createSlice({
  name: "errors",
  initialState: [],
  reducers: {
    add: (state, action) => {
      // Het moment van optreden. Stond er niet in, waardoor het scherm `moment(undefined)` las en
      // dus altijd "nu" toonde; in een foutrapport is dat precies het verkeerde getal.
      action.payload.key = moment().valueOf()
      state.push(action.payload)
    },
    remove: (state, action) => {
      state.splice(action.payload.index, 1)
    },
    clear: (state) => {
      return []
    }
  }
})

export const notificationsSlice = createSlice({
  name: "notifications",
  initialState: [],
  reducers: {
    add: (state, action) => {
      // Unieke key koppelen aan error
      action.payload.key = moment().valueOf()
      state.push(action.payload)
    },
    remove: (state, action) => {
      state.splice(action.payload.index, 1)
    },
    clear: (state) => {
      return []
    }
  }
})

export const { add: addError, remove: removeError, clear: clearErrors } = errorsSlice.actions
export const { add: addNotification, remove: removeNotification, clear: clearNotifications } = notificationsSlice.actions

export const errorsReducer = errorsSlice.reducer
export const notificationsReducer = notificationsSlice.reducer

// Een afgebroken request, in de twee vormen waarin hij hier aankomt: als de tekst uit
// `makeRequest` (XHR), of als de `AbortError` die `fetch` gooit.
const isAborted = (exception, message) =>
  exception?.name === "AbortError" || message.includes(REQUEST_ABORTED)

export const catchMessage = (json, functionName, successText) => (dispatch) => {
  let message = "Error"
  let type = (json && json.type && json.type.toLowerCase())

  if (json) {
    if (type === "success" || successText) {
      if (successText) {
        message = successText
        type = (type ? type : "info")
      } else {
        return null
      }
    } else {
      if (json.exception) {
        message = json.exception.toString()

        // Een afgebroken request is geen fout van de gebruiker maar van onszelf: elke pagina breekt
        // zijn lopende verzoeken af als je hem verlaat. Dat als foutdialoog tonen betekent dat je
        // een melding krijgt omdat je hebt doorgeklikt. Hier stoppen, in plaats van bij de dertig
        // aanroepers die allemaal hun eigen `catch` hebben.
        if (isAborted(json.exception, message)) return null

        if (!type) {
          type = "critical"
        }
      } else {
        return null
      }
    }
  }

  if (type === "critical") {
    dispatch(addError({
      message: message,
      number: json && json.exception && json.exception.number,
      level: json && json.exception && json.exception.level,
      function: functionName,
      type: type
    }))
  } else {
    dispatch(addNotification({
      message: message,
      type: type
    }))
  }
}